import {ExpandMore} from '@mui/icons-material';
import {Accordion, AccordionDetails, AccordionSummary, Box, Paper, Stack, Typography} from '@mui/material';
import {ModuleTopic, QuizSession, QuizTimedMode} from '@cp/model';
import TopicSelection from '../../components/TopicSelection/TopicSelection';
import {env} from '../../config/env';

export interface SessionCompleteDetailsProps {
  session: QuizSession;
  moduleTopics: ModuleTopic[];
}

export default function SessionCompleteDetails({session, moduleTopics}: SessionCompleteDetailsProps) {
  const getSessionModeLabel = (mode: QuizTimedMode) => {
    switch (mode) {
      case QuizTimedMode.PRACTICE:
        return 'Practice';
      case QuizTimedMode.TIMED:
        return 'Timed';
      case QuizTimedMode.TIMED_PER_QUESTION:
        return 'Timed per Question';
      default:
        return 'Unknown';
    }
  };
  return (
    <Paper sx={{p: 3}}>
      <Typography variant="h6" sx={{fontWeight: 600, mb: 2}}>
        Session Details
      </Typography>
      <Stack spacing={2}>
        <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
          <Typography variant="body2" color="text.secondary">
            Module:
          </Typography>
          <Typography variant="body2" sx={{fontWeight: 500}}>
            {session.moduleName || session.moduleId}
          </Typography>
        </Box>

        {/* Topics Accordion */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography variant="body2" color="text.secondary">
              Topics ({session.topics?.length || 0})
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {moduleTopics.length > 0 ? (
              <TopicSelection
                moduleTopics={moduleTopics}
                selectedTopics={session.topics}
                onSelectionChange={() => {}} // Read-only
                height={200}
                showSelectAll={false}
                disabled
              />
            ) : (
              <Typography variant="body2" color="text.secondary">
                {session.topics?.join(', ') || 'All topics'}
              </Typography>
            )}
          </AccordionDetails>
        </Accordion>

        <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
          <Typography variant="body2" color="text.secondary">
            Difficulty:
          </Typography>
          <Typography variant="body2" sx={{fontWeight: 500}}>
            {session.difficulty ? `Level ${session.difficulty}` : env.label.levelAuto}
          </Typography>
        </Box>

        <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
          <Typography variant="body2" color="text.secondary">
            Mode:
          </Typography>
          <Typography variant="body2" sx={{fontWeight: 500}}>
            {getSessionModeLabel(session.timedMode)}
          </Typography>
        </Box>
      </Stack>
    </Paper>
  );
}
